import { AxiosError } from 'axios';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { Invoice } from '../../../providers/api/dtos';
import { getInvoices } from '../../../providers/api/invoice/invoiceProvider';
import { PaginatedResult } from '../../../providers/pagination';
import { DEFAULT_PAGINATION_SIZE } from '../../../utils/querystring/querystring';

export const getUseInvoiceByPropertyIdRid = (propertyId: number) => ['/api/v4/invoices', 'property', propertyId];

export default function useInvoicesByPropertyId(
  propertyId?: number,
  options?: SWRConfiguration<PaginatedResult<Invoice>, AxiosError>,
): SWRResponse<PaginatedResult<Invoice>, AxiosError> {
  const key = propertyId ? getUseInvoiceByPropertyIdRid(propertyId) : null;
  const result = useSWR(key, () => getInvoices({
    propertyId,
  }, {
    size: DEFAULT_PAGINATION_SIZE,
  }), options);

  return result;
}
